import React from "react";
import { convertMultipleNewlinesToBR } from "../exports/functions";
import { marked } from "marked";

const WhyEga = (props) => {
  const { whyEgaData } = props;
  const rawDescription = whyEgaData[0]?.description || "";
  const description = convertMultipleNewlinesToBR(rawDescription);
  return (
    <>
      <section
        className={`about-three pb-120 position-relative z-1 overflow-hidden`}
        id="whyega"
      >
        <div className="position-relative">
          <div className="container">
            <div className="row gy-xl-0 gy-5 flex-wrap-reverse align-items-center">
              <div className="col-xl-6 pe-xl-5">
                <div className="about-three-thumbs position-relative me-xxl-5">
                  <div className="row gy-4">
                    <div className="col-sm-12">
                      <img
                        src={`${process.env.REACT_APP_cmsUrl}${whyEgaData[0]?.image[0]?.media?.url}`}
                        alt=""
                        className="rounded-16 w-100"
                        data-tilt=""
                        data-tilt-max={16}
                        data-tilt-speed={500}
                        data-tilt-perspective={5000}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="about-three-content">
                  <div className="mb-40">
                    <div className="flex-align d-inline-flex gap-8 mb-16 wow bounceInDown">
                      <span className="text-main-600 text-2xl d-flex">
                        <i className="ph-bold ph-book-open" />
                      </span>
                      <h5 className="text-main-600 mb-0">
                        {whyEgaData[0]?.snippet}
                      </h5>
                    </div>
                    <h2 className="mb-24 wow bounceInRight">
                      {whyEgaData[0]?.title}
                    </h2>
                    <p
                      className="text-neutral-500 text-line-2 wow bounceInUp"
                      dangerouslySetInnerHTML={{
                        __html: marked(description),
                      }}
                    ></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyEga;
